<template>
  <AccountSettings />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import AccountSettings from "../../components/Generals/AccountSettings/AccountSettings.vue";

export default defineComponent({
  name: "AccountSettingsPage",
  components: {
    AccountSettings,
  },
});
</script>
